.linked-modal-navigation-button:focus {
  background: inherit;
}
